import React from "react";
import { Content } from "./NoRecord.styled";
const NoRecord = () => {
  return (
    <Content>
      <div>No records to display</div>
    </Content>
  );
};

export default NoRecord;
